import React, { useEffect, useState } from "react";
import AdvancedSearchButton from "../../common/archive/AdvancedSearchButton";
import ArchiveModal from "../../common/archive/ArchiveModal";
import VerificationIcon from "../../common/VerificationIcon";
import styles from "../../common/archive/AdvancedSearch.module.scss";
import verifiedStyles from "../person-db/PersonDB.module.scss";
import DBSearchWidget from "./DBSearchWidget";
import PersonTypeHelper from "./PersonTypeHelper";
import AdvancedSearchTermInput from "../../common/archive/AdvancedSearchTermInput";
import { SearchParam } from "../../common/archive/ListSearchFunc";
import { SonicTermData } from "../../common/classes/SonicTerm";
import { parseTerms } from "../../utils/GeneralUtils";

type Props = {
  keywordParam: string;
  gameParams: Array<string>;
  typeParams: Array<string>;
  verifiedParam: string;
  gameOptions: Array<SonicTermData>;
  playerTypeOptions: Array<SonicTermData>;
  clearSearch: () => void;
  searchHandler: (params: Array<SearchParam>) => void;
};

const AdvancedSearchPerson: React.FC<Props> = ({
  keywordParam,
  gameParams,
  typeParams,
  verifiedParam,
  gameOptions,
  playerTypeOptions,
  clearSearch,
  searchHandler,
}) => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const [inputKeyword, setInputKeyword] = useState<string>(keywordParam);
  const [selectedGames, setSelectedGames] = useState<Array<string>>(gameParams);
  const [selectedPlayerTypes, setSelectedPlayerTypes] =
    useState<Array<string>>(typeParams);
  const [selectedVerified, setSelectedVerified] =
    useState<string>(verifiedParam);

  // ヘッダーメニューから1ページ目に戻った場合リセットする
  useEffect(() => {
    setInputKeyword(keywordParam);
  }, [keywordParam]);

  useEffect(() => {
    setSelectedGames(gameParams);
  }, [gameParams]);

  useEffect(() => {
    setSelectedPlayerTypes(typeParams);
  }, [typeParams]);

  useEffect(() => {
    setSelectedVerified(verifiedParam);
  }, [verifiedParam]);

  const handleAddTag = (field: string, value: string) => {
    switch (field) {
      case "games":
        setSelectedGames([...selectedGames, value]);
        break;
      case "player_types":
        setSelectedPlayerTypes([...selectedPlayerTypes, value]);
        break;
      default:
        break;
    }
  };

  const handleRemoveTag = (field: string, index: number) => {
    switch (field) {
      case "games":
        setSelectedGames(
          selectedGames.filter((game) => game !== selectedGames[index])
        );
        break;
      case "player_types":
        setSelectedPlayerTypes(
          selectedPlayerTypes.filter(
            (type) => type !== selectedPlayerTypes[index]
          )
        );
        break;
      default:
        break;
    }
  };

  const calcSearchConditionCount = () => {
    let num = selectedGames.length + selectedPlayerTypes.length;

    if (inputKeyword && inputKeyword !== "") {
      num++;
    }

    if (selectedVerified && selectedVerified !== "") {
      num++;
    }

    return num;
  };

  const handleSearch = () => {
    searchHandler([
      { field: "games", value: selectedGames },
      { field: "player_types", value: selectedPlayerTypes },
      { field: "verified", value: selectedVerified },
      { field: "s", value: inputKeyword },
    ]);

    setModal(false);
  };

  const setModal = (value: boolean) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setIsModalShown(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);

  return (
    <>
      <AdvancedSearchButton
        openModal={() => setModal(true)}
        searchConditionCount={calcSearchConditionCount()}
      />
      <ArchiveModal isOpen={isModalShown} handleClose={() => setModal(false)}>
        <div className={styles["c-advanced-search"]}>
          <AdvancedSearchTermInput
            handleChange={handleAddTag}
            handleRemove={handleRemoveTag}
            options={parseTerms(gameOptions, "name")}
            selectedTerms={selectedGames}
            id={"game-input"}
            field={"games"}
            label={"Game: "}
            placeholder={"ゲームで絞り込む"}
          />
          <AdvancedSearchTermInput
            handleChange={handleAddTag}
            handleRemove={handleRemoveTag}
            options={parseTerms(playerTypeOptions, "name")}
            selectedTerms={selectedPlayerTypes}
            id={"type-input"}
            field={"player_types"}
            label={"Type: "}
            placeholder={"タイプで絞り込む"}
            helper={
              <PersonTypeHelper
                options={parseTerms(playerTypeOptions, "name")}
              />
            }
          />
        </div>
        <DBSearchWidget
          keyword={inputKeyword}
          handleSearch={handleSearch}
          handleClear={() => {
            clearSearch();
            setModal(false);
          }}
          handleChange={(value: string) => {
            setInputKeyword(value);
          }}
        >
          <div className={verifiedStyles["sortbox-badge"]}>
            <div className={verifiedStyles["sortbox__title"]}>
              <VerificationIcon />
              認証バッジで絞る
            </div>
            <input
              type="radio"
              value=""
              onChange={() => {
                setSelectedVerified("");
              }}
              checked={selectedVerified === ""}
              name="sortBadge"
              id="noset"
            />
            <label htmlFor="noset">絞り込みなし</label>
            <input
              type="radio"
              value="isVerified"
              onChange={() => {
                setSelectedVerified("true");
              }}
              checked={selectedVerified === "true"}
              name="sortBadge"
              id="isVerified"
            />
            <label htmlFor="isVerified">認証バッジあり</label>
            <input
              type="radio"
              value="notVerified"
              onChange={() => {
                setSelectedVerified("false");
              }}
              checked={selectedVerified === "false"}
              name="sortBadge"
              id="notVerified"
            />
            <label htmlFor="notVerified">認証バッジなし</label>
          </div>
        </DBSearchWidget>
      </ArchiveModal>
    </>
  );
};

export default AdvancedSearchPerson;
